













































/**
 * 홈 - 도서 - 연재 - 상세
 * 메뉴명: 연재 상세
 * 메뉴이름: BOOK_SERIES_EPISODE_DETAIL
 */
import { useRouter } from '@u3u/vue-hooks';
import { computed, defineComponent, nextTick, ref, watch } from '@vue/composition-api';

import { SerialEpisodeDetailDTO } from '@/apis/repositories/types/serial';
import { createSerialComment, fetchSerialEpisodeDetail } from '@/apis/services/serialService';
import { Breadcrumb, LineBreakElement } from '@/components/base';
import LiteraryCommentPost, { LiteraryCommentPostType } from '@/components/views/book/LiteraryCommentPost.vue';
import LiteraryDetailPaging from '@/components/views/book/LiteraryDetailPaging.vue';
import { useAlert } from '@/composables';
import { ROUTE_NAMES, SHARE_TYPE } from '@/constants';
import logger from '@/modules/logger';
import { userStore } from '@/store';
import { scrollUtil } from '@/utils/scrollInfo';
import { share } from '@/utils/share';

const NEXT_VERSION = true;

export default defineComponent({
  name: 'BookSeriesEpisodeDetailPage',
  components: {
    Breadcrumb,
    LiteraryDetailPaging,
    LineBreakElement,
    LiteraryCommentPost,
  },
  setup() {
    const alertModal = useAlert();

    const { route, router } = useRouter();
    const literaryCommentPostRef = ref<LiteraryCommentPostType>();

    const episode = ref<SerialEpisodeDetailDTO | null>(null);

    const episodeId = computed(() => {
      return Number(route.value.params.episodeId);
    });
    const seriesId = computed(() => {
      return Number(route.value.params.seriesId);
    });

    const chapterText = computed(() => {
      if (episode.value) {
        return episode.value.no !== null ? `${episode.value.no}회` : '공지';
      }

      return '';
    });

    const isNextExist = computed(() => {
      return !!episode.value && episode.value.nextSeq !== null;
    });

    const isPreviousExist = computed(() => {
      return !!episode.value && episode.value.previousSeq !== null;
    });

    const isLogin = computed(() => {
      // !FIXME: 현재 무조건 로그인 했다고 가정(나중 버전에서 주석 사용)
      // return userStore.isLogin;
      return NEXT_VERSION || userStore.isLogin;
    });

    const replyDisabled = computed(() => {
      return !isLogin.value;
    });

    console.log(replyDisabled.value);

    const replyPlaceholder = computed(() => {
      return isLogin.value ? '최소10자에서 200자내로 연재에 대한 의견을 전달해 주세요' : '로그인 후 이용 가능합니다.';
    });

    const routToOtherEpisode = (episodeId: number) => {
      router.push({
        name: ROUTE_NAMES.BOOK_SERIES_EPISODE_DETAIL,
        params: {
          seriesId: String(seriesId.value),
          episodeId: String(episodeId),
        },
      });
    };

    const nextClickHandler = () => {
      if (episode.value) {
        routToOtherEpisode(episode.value.nextSeq as number);
      }
    };

    const previousClickHandler = () => {
      if (episode.value) {
        routToOtherEpisode(episode.value.previousSeq as number);
      }
    };

    const shareClickHandler = () => {
      share({
        type: SHARE_TYPE.SERIAL_ITEM,
        seq: seriesId.value,
        itemSeq: episodeId.value,
      });
    };

    const toMenuClickHandler = () => {
      router.push({ name: ROUTE_NAMES.BOOK_SERIES_DETAIL, params: { seriesId: String(seriesId.value) } });
    };

    const registerClickHandler = async (contents: string) => {
      const inputContents = contents.trim();
      if (inputContents.length === 0) {
        return;
      }
      try {
        await createSerialComment(episodeId.value, {
          contents: inputContents,
        });
        alertModal.show({
          message: '회원님의 소중한 의견을 최대한 반영할 수 있도록 노력하겠습니다. 감사합니다.',
          onOk() {
            literaryCommentPostRef.value?.resetContents();
          },
        });
      } catch {
        alertModal.show({
          message: '댓글 등록에 실패했습니다. 다시 시도해주세요.',
        });
      }
    };

    watch(
      () => [route.value.params.episodeId, route.value.params.seriesId],
      async () => {
        try {
          window.scrollTo(0, 0);
          episode.value = await fetchSerialEpisodeDetail(episodeId.value);
        } catch (e) {
          logger.log('alpha', 'fetchSerialEpisodeDetail 실패', e);
        }
        nextTick(() => {
          scrollUtil.applyScroll();
        });
      },
      { immediate: true },
    );

    return {
      literaryCommentPostRef,
      episode,
      isNextExist,
      isPreviousExist,
      chapterText,
      replyDisabled,
      replyPlaceholder,
      nextClickHandler,
      previousClickHandler,
      shareClickHandler,
      toMenuClickHandler,
      registerClickHandler,
    };
  },
});
